const initialState = {
  list: [],
  loading: 'idle',
  selectedTax: {},
};

export default initialState;
